export default {
    success: {
        accept: 'The micro-trend <strong>"{title}"</strong> was successfully added to the work space.',
        reject: 'The micro-trend <strong>"{title}"</strong> was successfully declined.'
    }
}
